export const version = "logger/5.4.1";
